import { TooltipIcon } from "../../../../../../components";
import { Sizes } from "../../../../../../components/Icon";

type Props = {
  className?: string;
  message: string;
  size?: Sizes;
};

const WarningIcon = ({ className, message, size }: Props) => (
  <TooltipIcon
    icon="warning-i"
    className={className}
    style={{ color: "#ff8000" }}
    size={size}
    message={message}
  />
);

export default WarningIcon;
